<template>
  <div class="img">
      <img :src="imgData" :alt="alt">
  </div>
</template>

<script>
export default {
  props:['type','alt'],
  name:'banner-img',
  data(){
      return{
        imgData:''
      }
  },
  created() {
    this.$api.homepage.banner({
      type:this.type
    }).then(res=>{
      this.imgData= res.data[0].image
    })
  },
}
</script>

<style lang="less" scoped>
.img{
    width: 1920px;
    height:300px;
    img{
        width: 1920px;
        height:300px;
    }
}
</style>